import React, { useState } from "react";
import Loader from "react-js-loader";
import Breadcrumbs from "../../globals/core/Breadcrumbs/Breadcrumb";
import { useSelector } from 'react-redux';
import SyncCurricula from "./SyncCurricula";
import SyncSeminars from "./SyncSeminars";
import DuplicateSessions from "./DuplicateSessions";

export const Settings = () => {
  const { me } = useSelector((state) => state.auth);
  const { role } = me || {};

  const isCurriculaManager = role === 'Administrator'
    || role === 'Curricula Manager'
    || role === 'Event + Curricula Manager';
  const isEventManager = role === 'Administrator'
    || role === 'Event Manager'
    || role === 'Event + Curricula Manager';

  const [isLoading, setIsLoading] = useState(false);

  return (
    <div className="content">
      <div className="page-content">
        <div className="container-fluid">
          <div className="mb-3">
            <Breadcrumbs title="MAIN" breadcrumbItem="SETTINGS" />
          </div>

          {isCurriculaManager &&
            <SyncCurricula
              role={role}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
            />
          }

          {isEventManager &&
            <>
              <SyncSeminars
                isLoading={isLoading}
                setIsLoading={setIsLoading}
              />
              <DuplicateSessions
                setIsLoading={setIsLoading}
              />
            </>
          }

          {isLoading &&
            <Loader type="spinner-circle"
              bgColor="#00b78c"
              title="Sync is in process, please wait..."
              color="#00b78c"
              size={50}
            />
          }
        </div>
      </div>
    </div>
  );
};
